export const ticketTransferKeys = {
    all: ['ticketTransfer'] as const,
    options: (centerId: string, memberId: string) =>
        [...ticketTransferKeys.all, 'options', centerId, memberId] as const,
    list: (centerId: string) => [...ticketTransferKeys.all, 'list', centerId] as const,
};

